document.addEventListener('alpine:init', () => {
    Alpine.store('showModal', false)
})
